<div
    *ngFor="let group of channelGroupList; let i = index"
    class="group-list"
    data-cy="channels-side-menu-channel-group-list-item"
    [class.active]="group.id === activeGroup?.id"
    (click)="selectGroup(group)">
    <div class="group-row-wrapper">
        <div class="text" data-cy="channels-side-menu-channel-group-index">
            {{ group.rowNum }}
        </div>
        <div class="text" data-cy="channels-side-menu-channel-group-name">
            {{ group.displayName }}
        </div>
        <div class="sub-title" data-cy="channels-side-menu-channel-group-category">
            {{ group.categoryId ? group.channelCategory.category : '' }}
        </div>
    </div>

    <mat-icon
        svgIcon="more-options"
        class="icon"
        data-cy="channels-side-menu-channel-group-kebab-icon"
        (click)="openMore($event, group)"></mat-icon>
</div>
